import { mergeStyles } from '../../../../../internal/utils/mergeStyles';
import mainStyles from './styles.module.css';
import { getDeviceStyles, getDeviceStylesIdentity } from './device';
import { memoizeWith } from 'ramda';
function getModalWindowStyles(deviceType, size) {
  var deviceStyles = getDeviceStyles(deviceType, size);
  return mergeStyles(mainStyles, deviceStyles);
}
export var getStyles = memoizeWith(getDeviceStylesIdentity, getModalWindowStyles);